import React from 'react';

import classNames from 'classnames';

import { ReactComponent as IconLoaderBold } from 'media/svg/loaderBold.svg';
import { ReactComponent as IconLoaderThin } from 'media/svg/loaderThin.svg';

import { ConditionalWrapper } from 'utility/Check/ConditionalWrapper';

import styles from './Spinner.module.scss';

export interface SpinnerProps {
    type?: 'thin' | 'bold';
    classListObject?: {
        CustomClass?: string;
        AreaSpinner?: string;
        Spinner?: string;
    };
    areaSpinner?: boolean;
}

const Spinner = ({
    areaSpinner = false,
    type = 'thin',
    classListObject,
}: SpinnerProps) => {
    const SpinnerIcon =
        type === 'thin' ? <IconLoaderThin /> : <IconLoaderBold />;
    const classListAreaSpinner = classNames(
        styles.AreaSpinner,
        classListObject?.AreaSpinner
    );
    const classListSpinner = classNames(
        styles.Spinner,
        classListObject?.Spinner
    );

    return (
        <ConditionalWrapper
            condition={areaSpinner}
            wrapper={(children: React.ReactElement) => (
                <div id="AreaSpinner" className={classListAreaSpinner}>
                    {children}
                </div>
            )}
        >
            <span className={classListSpinner}>{SpinnerIcon}</span>
        </ConditionalWrapper>
    );
};

export default Spinner;
